<div class="modal-header modal-pepsico-header">
  <h1 class="modal-title fs-5" id="exampleModalLabel">COMPARTIR {{ title() | uppercase }}</h1>
</div>
<div class="modal-body">
  <div class="order-tracking-unique">
    <p>
      Comparte {{ description() }} de premios con familiares y amigos. ¡Es muy fácil! Ingresa el correo electrónico de
      la persona con quien deseas compartirlo y ¡listo!
    </p>
    <h5><b>Añadir personas</b></h5>
    <form [formGroup]="form">
      <div class="mt-3">
        <div class="mb-2">
          <label class="form-label">Alias de contacto:</label>
          <input type="text" class="form-control" formControlName="alias" onlyName maxlength="80">
          @if (formUtils.isValidField(form, 'alias')) {
          <form-error-label [control]="form.get('alias')!" />
          }
        </div>
      </div>
      <div class="mt-3">
        <div class="mb-2">
          <label class="form-label">Ingresa un correo electrónico:</label>
          <input type="email" class="form-control" formControlName="email" formControlName="email" maxlength="120">
          @if (formUtils.isValidField(form, 'email')) {
          <form-error-label [control]="form.get('email')!" />
          }
        </div>
      </div>

      <small class="fnt-12">
        <svg-icon svgName="bi-info-circle-fill" [width]="16" [height]="16" />
        Las personas invitadas pueden crear listas, agregar o eliminar artículos de tus listas.
      </small>
      <div class="d-flex jf-center mt-3" *ngIf="wishListId() !=''">
        <button type="button" class="btn btn-primary perfilbtn-pep" (click)="sharedWishList()">Compartir</button>
      </div>
      <div class="d-flex jf-center mt-3" *ngIf="wishListId() ==''">
        <button type="button" class="btn btn-primary perfilbtn-pep" (click)="ngbActiveModal.close()">Cerrar</button>
      </div>
    </form>
  </div>
</div>